import { RequestErrorCode, ResponseErrorCode } from "univapay-node";

import * as checkoutErrors from "./labels/errors";

const Errors = { ...RequestErrorCode, ...ResponseErrorCode, ...checkoutErrors };
const ErrorKeySet = new Set(
    Object.keys(Errors).reduce((errors: string[], key: string) => errors.concat([Errors[key]]), [])
);

export const errorCodeLabel = (code: string) => (ErrorKeySet.has(code) ? code : Errors.UnknownError);
